import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, ElementRef, HostBinding, Input } from '@angular/core';
import { CanColor, mixinColor } from '@angular/material/core';

export type RdsSelectableIconPos = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

export const _SelectableItemMixinBase = mixinColor(
  class {
    constructor(public _elementRef: ElementRef) {}
  },
  'primary'
);

/* eslint-disable @angular-eslint/no-inputs-metadata-property */
@Directive({
  selector: '[rdsSelectable]',
  inputs: ['color'],
})
export class RdsSelectableDirective extends _SelectableItemMixinBase implements CanColor {
  static ngAcceptInputType_rdsSelectableSelected: BooleanInput;
  static ngAcceptInputType_rdsSelectableIconFont: string | null | undefined;
  static ngAcceptInputType_rdsSelectableIconPadding: string | null | undefined;
  @HostBinding('class.rds-c-selectable') selectable = true;

  /** Icon to be displayed on the selected item. Defaults to `check_circle` */
  @HostBinding('attr.data-rds-selectable-icon')
  @Input()
  rdsSelectableIcon = 'check_circle';

  /** Font Family of the selectable icon. Defaults to `Material Icons` */
  @Input()
  get rdsSelectableIconFont(): string {
    return this._rdsSelectableIconFont;
  }
  set rdsSelectableIconFont(font: string) {
    if (font) {
      this.el.nativeElement.style.setProperty('--rds-selectable-icon-font', font);
      this._rdsSelectableIconFont = font;
    }
  }
  private _rdsSelectableIconFont = 'Material Icons';

  /**
   * Sets the padding of the icon from the edges of the parent. Supports all padding values, `px`, `em`, `%`, etc.
   * NOTE: Not supported in IE
   */
  @Input()
  get rdsSelectableIconPadding(): string {
    return this._rdsSelectableIconPadding;
  }
  set rdsSelectableIconPadding(padding: string) {
    if (padding) {
      this.el.nativeElement.style.setProperty('--rds-selectable-icon-padding', padding);
      this._rdsSelectableIconPadding = padding;
    }
  }
  private _rdsSelectableIconPadding = '0';

  /** Where to position the selected icon. `top-right` | `top-left` | `bottom-right` | `bottom-left`. Defaults to `top-right` */
  @Input()
  get rdsSelectablePosition() {
    return this._rdsSelectablePosition;
  }
  set rdsSelectablePosition(pos: RdsSelectableIconPos) {
    if (!!pos && pos !== this._rdsSelectablePosition) {
      this.el.nativeElement.classList.replace(`icon-${this._rdsSelectablePosition}`, `icon-${pos}`);
      this._rdsSelectablePosition = pos;
    }
  }
  private _rdsSelectablePosition: RdsSelectableIconPos = 'top-right';

  /** Whether the item is selected */
  @HostBinding('class.rds-selectable-selected')
  @Input()
  get rdsSelectableSelected(): boolean {
    return this._rdsSelectableSelected;
  }
  set rdsSelectableSelected(s: boolean) {
    this._rdsSelectableSelected = coerceBooleanProperty(s);
  }
  private _rdsSelectableSelected = true;

  constructor(protected el: ElementRef<HTMLElement>) {
    super(el);
    this.el.nativeElement.classList.add(`icon-${this._rdsSelectablePosition}`);
  }
}
